@if (marketScreenState === 'PRODUCT') {
    <div class="product-empty-div"></div>
}
<button (click)="resetAllFilters()" matButton="elevated" class="btn_reset" color="primary">
    Filter zurücksetzen
</button>
<div class="side-filter-container">
    <!--     
    <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Suche</mat-label>
        <div class="search">
            <input
                matInput
                placeholder="Schlagwort"
                [(ngModel)]="searchText"
                (keydown.enter)="this.filterBySearchText()"
                (keydown.escape)="$event.stopPropagation()"
                [formControl]="prodControl"
                [matAutocomplete]="auto"
            />

            <button
                mat-mini-fab
                color="primary"
                (click)="this.filterBySearchText()"
            >
                <mat-icon matPrefix color="accent">search</mat-icon>
            </button>
        </div>
        <mat-autocomplete #auto="matAutocomplete">
            <mat-option
                *ngFor="let option of filteredOptions | async"
                [value]="option"
            >
                {{ option }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
    -->


    <div class="scrollable-container-small filter-container">
        <!--         <div *ngIf="marketScreenState === 'PRODUCT'" style="margin-top: 1vw;">
            <span class="filterTitle">
                <h3>Produktkategorie</h3>
                <button class="filter-btn" mat-icon-button color="primary" (click)="minimiseProductKategorie = !minimiseProductKategorie" >
                    <mat-icon>{{ minimiseProductKategorie ? 'remove' : 'add' }}</mat-icon>
                </button>
            </span>
            <mat-divider></mat-divider>
            <div [@openClose]="minimiseProductKategorie ? 'open' : 'closed'"  class="showHide">
                <section *ngFor="let productItem of productCategoryCheckboxItems;   index as i">
                    <mat-checkbox class="checkbox" [(ngModel)]="productItem.checked" (change)="_receiveCheckedValueProductCertificationType('PRODUCT_PROVIDER',i);
                        toggleProductCheckBoxes(productItem.value, true)">
                    {{ productItem.name }}
                    </mat-checkbox>
                </section>
            </div>
        </div> -->

        <!--PTGs & Filteroption innerhalb der PTG-checkboxes-->
        <div *ngIf="marketScreenState === 'PRODUCT'" class="scroll-container">
            <span class="filterTitle">
                <h3>{{ getCurrentRoute().includes('category=Datenbanken')?
                    "Datenbanktyp" : getCurrentRoute().includes('category=Fachpublikationen')? "Publikationstyp" :
                    "Produkttyp" }}
                    <!-- <mat-chip class="active-count" *ngIf="getptgActiveEntryCount(ptgCheckboxes) > 0">
                        {{ getptgActiveEntryCount(ptgCheckboxes) }}
                    </mat-chip> -->
                </h3>
                @if (getptgActiveEntryCount(ptgCheckboxes) > 0) {
                    <span class="selected-filter-count">
                        {{ getptgActiveEntryCount(ptgCheckboxes) }}
                    </span>
                }
                <!--<button  class="filter-btn"
                    mat-icon-button
                    color="primary"
                    (click)="showProducttypeFilter = !showProducttypeFilter"
                >
                    <mat-icon
                        [class]="{
                            'material-icons-outlined': !producttypeFilterString
                        }"
                        >filter_alt</mat-icon
                    >
                </button> -->
                <button class="filter-btn" mat-icon-button color="primary" aria-label="Öffnen oder Schließen Button"
                    (click)="minimiseProductTypen = !minimiseProductTypen">
                    <mat-icon>{{ minimiseProductTypen ? 'remove' : 'add' }}</mat-icon>
                </button>
            </span>
            <mat-divider></mat-divider>
            <div [@openClose]="showProducttypeFilter ? 'open' : 'closed'" class="filterPanel">
                <mat-form-field appearance="outline" [floatLabel]="'never'" style="width: 95%">
                    <input matInput type="text" placeholder="Suche" [(ngModel)]="producttypeFilterString" />
                    <mat-icon matPrefix>search</mat-icon>
                    <button class="filter-btn" mat-button *ngIf="producttypeFilterString" matSuffix mat-icon-button
                        aria-label="Clear" (click)="producttypeFilterString = ''">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
            </div>
            <div [@openClose]="minimiseProductTypen ? 'open' : 'closed'" class="showHide">
                <section [class]="{ scrollpane: ptgCheckboxes.length > 5, producttypes: ptgCheckboxes.length < 5 }"
                    style="height: auto; margin-bottom: 1.5em">
                    <ng-container
                        *ngFor="let ptg of ptgCheckboxes | filter : producttypeFilterString; let last = last; let i = index">
                        <div *ngIf="isPtgIncludedInCategory(ptg)">
                            <mat-checkbox class="checkbox" name="organisationList" [checked]="ptg.isChecked"
                                (change)="_receiveCheckedValue(ptg, $event)">
                                {{ ptg.label }}
                            </mat-checkbox>
                            <br *ngIf="!last" />
                        </div>
                    </ng-container>
                </section>
            </div>
        </div>

        <div *ngIf="(marketScreenState === 'ORGANISATION') 
             && (!getCurrentRoute().includes('category='))" class="scroll-container">
            <span class="filterTitle">
                <h3>Zertifikate
                    <!-- <mat-chip class="active-count" *ngIf="getZertActiveEntryCount(certificationCheckboxes) > 0">
                        {{ getZertActiveEntryCount(certificationCheckboxes) }}
                    </mat-chip> -->
                </h3>
                @if (getZertActiveEntryCount(certificationCheckboxes) > 0) {
                    <span class="selected-filter-count">
                        {{ getZertActiveEntryCount(certificationCheckboxes) }}
                    </span>
                }
                <button class="filter-btn" mat-icon-button color="primary" (click)="checkBoxesAndToggleCert()">
                    <mat-icon>{{ minimiseZert ? 'remove' : 'add' }}</mat-icon>
                </button>
            </span>
            <mat-divider></mat-divider>
            <div [@openClose]="minimiseZert ? 'open' : 'closed'" class="showHide">
                <section>
                    <!-- CHECKBOXES FOR CERTIFICATIONFILTER ON CERTIFICATION MARKETPLACE PAGE  -->
                    <!-- CHECKBOXES FOR CERTIFICATION FILTER ON PRODUCT MARKETPLACE PAGE  -->
                    <ul [class]="{ scrollpane: certificationCheckboxes.length > 5 }"
                        *ngIf="minimiseZert && marketScreenState === 'ORGANISATION'">
                        <!--ATTRIBUTE/MERKMAL ZERTIFIKATE-->
                        <div *ngFor="let certItem of certificationCategoryCheckboxItems; index as i">
                            <div style="height: auto" *ngIf="certItem.value === 'ATTRIBUTE_CERT'">
                                <li *ngFor="let certProviders of certificationCheckboxes; let i = index">
                                    <mat-checkbox class="subcheckbox" [(ngModel)]="certProviders.isChecked" (change)="
                                        toggleCertificationSubCheckBoxes(certProviders.categorie, null);
                                        this._receiveCheckedValue(certProviders, $event)">
                                        {{ certProviders.label }}
                                    </mat-checkbox>
                                </li>
                            </div>
                        </div>
                    </ul>
                </section>
            </div>
        </div>



        <!-- CommonFeature-Filters with Entry-Checkboxes -->
        <div *ngIf="marketScreenState === 'PRODUCT'" class="scroll-container">
            <ng-container *ngFor="let commonFeature of commonFeatures">
                <ng-container *ngIf="featureAppliesToCurrentCategories(commonFeature)">
                    <span class="filterTitle">
                        <h3>{{ commonFeature.name }}
                            <!-- <mat-chip class="active-count" *ngIf="getActiveEntryCount(commonFeature) > 0">
                                {{ getActiveEntryCount(commonFeature) }}
                            </mat-chip> -->
                        </h3>
                        @if (getActiveEntryCount(commonFeature) > 0) {
                            <span class="selected-filter-count">
                                {{ getActiveEntryCount(commonFeature) }}
                            </span>
                        }
                        <button class="filter-btn" mat-icon-button color="primary"
                            (click)="commonFeature.showEntries = !commonFeature.showEntries">
                            <mat-icon>{{ commonFeature.showEntries ? 'remove' : 'add' }}</mat-icon>
                        </button>
                    </span>

                    <mat-divider></mat-divider>

                    <div [@openClose]="commonFeature.showEntries ? 'open' : 'closed'" class="showHide">
                        <section [class]="{ scrollpane: commonFeature.entries.length > 5 }" style="height: auto">
                            <ng-container *ngFor="let entry of commonFeature.entries; let last = last">
                                <div>
                                    <mat-checkbox *ngIf="!entry.pureName.includes(';')" name="commonFeatureEntryList"
                                        [(ngModel)]="entry.isChecked" [value]="entry.name"
                                        (change)="checkedCommonFeatureEntryBox(entry, $event)">
                                        {{ entry.name }}
                                    </mat-checkbox>
                                </div>
                                <div class="subCheckboxes" *ngIf="entry.id == fachPlanerId && entry.isChecked">
                                    <ng-container *ngFor="let fachPlanerEntry of fachPlanerEntries; let last = last">
                                        <mat-checkbox name="commonFeatureEntrySubList"
                                            [(ngModel)]="fachPlanerEntry.isChecked" [value]="fachPlanerEntry.name"
                                            (change)="checkedCommonFeatureEntryBox(fachPlanerEntry, $event)">
                                            {{ fachPlanerEntry.pureName.split(';')[1] }}
                                        </mat-checkbox>
                                    </ng-container>
                                </div>
                            </ng-container>
                        </section>
                    </div>
                </ng-container>
            </ng-container>
        </div>



        <div *ngIf="marketScreenState === 'PRODUCT'" class="scroll-container">
            <span class="filterTitle">
                <h3>Bewertungen
                    <!-- <mat-chip class="active-count" *ngIf="getRatingActiveCount() > 0">
                        {{ getRatingActiveCount() }}
                    </mat-chip> -->
                </h3>
                @if (getRatingActiveCount() > 0) {
                    <span class="selected-filter-count">
                        {{ getRatingActiveCount() }}
                    </span>
                }
                <button class="filter-btn" mat-icon-button color="primary" 
                    (click)="minimiseBewertungen = !minimiseBewertungen"
                >
                    <mat-icon>{{ minimiseBewertungen ? 'remove' : 'add' }}</mat-icon>
                </button>
            </span>

            <mat-divider></mat-divider>
            <div [@openClose]="minimiseBewertungen ? 'open' : 'closed'" class="showHide">
                <section *ngFor="let score of productRatingCheckboxItem">
                    <mat-checkbox *ngIf="score.value; else noScore" [(ngModel)]="score.checked"
                        (change)="_receiveCheckedValueRating(score.rating, $event)"
                    >
                        <div class="ratingStar"><app-star [rating]="score.rating"></app-star></div>
                    </mat-checkbox>

                    <ng-template #noScore>
                        <mat-checkbox [(ngModel)]="score.checked"
                            (change)="_receiveCheckedValueRatingAllWithout(score.rating, $event)"
                        >
                            <div class="ratingStar"><app-star [rating]="0"></app-star></div>
                        </mat-checkbox>
                    </ng-template>
                </section>
            </div>
        </div>
        <!--Anbieter & Filteroption innerhalb der Anbieter-checkboxes-->
        <div *ngIf="marketScreenState === 'CERTIFICATION' || marketScreenState === 'PRODUCT'" class="scroll-container">
            <!-- <span class="filterTitle">
                <h3>Anbieter</h3>
                <button class="filter-btn" mat-icon-button color="primary"
                    (click)="minimiseAnbieter = !minimiseAnbieter"
                >
                    <mat-icon>{{ minimiseAnbieter ? 'remove' : 'add' }}</mat-icon>
                </button>
            </span> 
            <mat-divider></mat-divider>
            <div [@openClose]="showProviderFilter ? 'open' : 'closed'" class="filterPanel">
                <mat-form-field appearance="outline" [floatLabel]="'never'" style="width: 95%">
                    <input matInput type="text" placeholder="Suche" [(ngModel)]="providerFilterString" />
                    <mat-icon matPrefix>search</mat-icon>
                    <button class="filter-btn" mat-button *ngIf="providerFilterString" matSuffix mat-icon-button
                        aria-label="Clear" (click)="providerFilterString = ''"
                    >
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
            </div>
            <div [@openClose]="minimiseAnbieter ? 'open' : 'closed'" class="showHide">
                <section [class]="{ scrollpane: organisationCheckboxes.length > 5 }"
                    style="height: auto; display: flex; flex-direction: column">
                    <ng-container
                        *ngFor="let org of organisationCheckboxes | filter : providerFilterString; let last = last; let i = index"
                    >
                        <div *ngIf="isOrgInCategory(org)">
                            <mat-checkbox name="organisationList" [checked]="org.isChecked"
                                (change)="_receiveCheckedValue(org, $event)"
                            >
                                {{ org.label }}
                            </mat-checkbox>
                        </div>
                    </ng-container>
                </section>
            </div>
        </div>
-->

            <!-- Organisation screen state-->
            <div *ngIf="marketScreenState === 'ORGANISATION'" class="scroll-container">
                <!-- <span class="filterTitle">
                <h3>Zertifizierungsanbieter</h3>
            </span>
            <mat-divider></mat-divider>
            <section *ngFor="let certificationOrganisationCategory of certificationCategoryCheckboxItems; index as i">
                <div *ngIf="certificationOrganisationCategory.value === 'ATTRIBUTE_CERT'"
                    [class]="{ scrollpane: attributeCertificationOrganisationCheckBoxes.length > 5 }"
                    style="height: auto">
                    <ul>
                        <li
                            *ngFor="let productItemCheckBox of attributeCertificationOrganisationCheckBoxes; index as i">
                            <mat-checkbox *ngIf="certificationOrganisationCategory.value === 'ATTRIBUTE_CERT'"
                                class="subcheckbox" [(ngModel)]="productItemCheckBox.isChecked" (change)="
                                    _receiveCheckedValue(productItemCheckBox, $event);
                                    toggleProductCheckBoxes(productItemCheckBox.categorie, false)">
                                {{ productItemCheckBox.label }}
                            </mat-checkbox>
                        </li>
                    </ul>
                </div>
                <div *ngIf="certificationOrganisationCategory.value === 'PTG_CERT'"
                    [class]="{ scrollpane: ptgCertificationOrganisationCheckBoxes.length > 5 }" style="height: auto">
                    <ul>
                        <li *ngFor="let productItemCheckBox of ptgCertificationOrganisationCheckBoxes; index as i">
                            <mat-checkbox class="subcheckbox" [(ngModel)]="productItemCheckBox.isChecked"
                                (change)="_receiveCheckedValue(productItemCheckBox, $event);
                                toggleProductCheckBoxes(productItemCheckBox.categorie, false)"
                            >
                                {{ productItemCheckBox.label }}
                            </mat-checkbox>
                        </li>
                    </ul>
                </div>
                <div *ngIf="certificationOrganisationCategory.value === 'TOOLCHAIN_CERT'"
                    [class]="{ scrollpane: toolchainCertificationOrganisationCheckBoxes.length > 5 }"
                    style="height: auto">
                    <ul>
                        <li
                            *ngFor="let productItemCheckBox of toolchainCertificationOrganisationCheckBoxes; index as i">
                            <mat-checkbox *ngIf="certificationOrganisationCategory.value === 'TOOLCHAIN_CERT'"
                                class="subcheckbox" [(ngModel)]="productItemCheckBox.isChecked" (change)="
                                    _receiveCheckedValue(productItemCheckBox, $event);
                                    toggleProductCheckBoxes(productItemCheckBox.categorie, false)">
                                {{ productItemCheckBox.label }}
                            </mat-checkbox>
                        </li>
                    </ul>
                </div>
            </section> -->
            </div>
        </div>
    </div>
